// Aviso de cookies (layouts/newstyle/cookies/_banner).
// - Aparece em toda página (inclusive nas trocas do Turbolinks), 1s depois de ela abrir, enquanto
//   a pessoa não escolher.
// - O botão grava a escolha por 1 ano: policy_alert_accepted (todos) ou
//   policy_alert_required_accepted (só os necessários).
// - "Aceitar todos" libera na hora o consentimento do Google Tag Manager (Consent Mode v2) e o
//   rastreio do HubSpot, sem recarregar; "só os necessários" mantém tudo negado (e nas próximas
//   páginas o GTM nem carrega). O estado inicial é montado em layouts/newstyle/_tracking_codes.

var CONSENT_COOKIES = ['policy_alert_accepted', 'policy_alert_required_accepted'];

function hasChosen() {
  return CONSENT_COOKIES.some(function(name) {
    return document.cookie.indexOf(name + '=') !== -1;
  });
}

function grantTracking() {
  window.dataLayer = window.dataLayer || [];
  // o gtag precisa receber o objeto "arguments", não um array
  var gtag = window.gtag || function() { window.dataLayer.push(arguments); };
  gtag('consent', 'update', {
    ad_storage: 'granted',
    ad_user_data: 'granted',
    ad_personalization: 'granted',
    analytics_storage: 'granted'
  });
  window.dataLayer.push({ event: 'cookie_consent_update', cookie_consent: 'all' });

  var hsq = window._hsq = window._hsq || [];
  hsq.push(['doNotTrack', { track: true }]);

  if (window.cdaCookieConsent) window.cdaCookieConsent.all = true;
}

// espera 1s depois de a página abrir, para o aviso não disputar a atenção com o carregamento;
// numa troca de página do Turbolinks antes disso, a contagem recomeça na página nova
var SHOW_DELAY = 1000;
var showTimer = null;

document.addEventListener('turbolinks:load', function() {
  clearTimeout(showTimer);
  if (hasChosen() || !document.getElementById('policy-alert')) return;
  showTimer = setTimeout(function() {
    var alert = document.getElementById('policy-alert');
    if (alert && !hasChosen()) alert.style.display = '';
  }, SHOW_DELAY);
});

document.addEventListener('click', function(event) {
  var button = event.target.closest && event.target.closest('[data-cda-cookie-accept]');
  if (!button) return;

  event.preventDefault();
  var choice = button.getAttribute('data-cda-cookie-accept');
  document.cookie = choice + '=true;path=/;max-age=31536000;SameSite=Lax';
  if (choice === 'policy_alert_accepted') grantTracking();

  var alert = document.getElementById('policy-alert');
  if (!alert) return;
  alert.classList.add('is-leaving');
  setTimeout(function() {
    alert.style.display = 'none';
    alert.classList.remove('is-leaving');
  }, 220);
});
